import type PaginationFilter from './store/PaginationFilter';

export default class PaginationHandler {
    readonly #paginationElement: HTMLElement | null;

    readonly #filter: PaginationFilter;

    constructor(paginationElement: HTMLElement, filter: PaginationFilter) {
        this.#paginationElement = paginationElement;
        this.#filter = filter;
        this.#setEventListener();
    }

    #setEventListener(): void {
        this.#paginationElement?.addEventListener('click', (event) => {
            event.preventDefault();

            if (!(event.target instanceof HTMLAnchorElement)) {
                return;
            }

            const url = new URL(event.target.href);
            const skip = parseInt(url.searchParams.get('skip') || '0', 10);
            const limit = parseInt(url.searchParams.get('limit') || '10', 10);

            this.#filter.setPagination(skip, limit);
        });
    }
}
